<template>
  <div class="container-layout">
    <sc-placeholder class="layout-item left" :rendering="rendering" name="digital-house-2h-container-left-tile"/>
    <sc-placeholder class="layout-item right" :rendering="rendering" name="digital-house-2h-container-right-tile"/>
  </div>
</template>

<script>
import { Placeholder } from '@sitecore-jss/sitecore-jss-vue'

export default {
  name: 'TileImageContainer',
  props: {
    fields: {
      type: Object,
      default: () => ({})
    },
    rendering: {
      type: Object
    }
  },
  components: {
    scPlaceholder: Placeholder
  }
}
</script>

<style lang="scss" scoped>
.container-layout {
  display: flex;
  flex-wrap: wrap;
  margin: $space-090 0;

  @include tablet() {
    flex-wrap: nowrap;
    margin: $space-100 $space-060;
  }

  .layout-item {
    width: 100%;

    &.right {
      margin-left: auto;
    }

    &.left + .right {
      margin-top: $space-080;

      @include tablet() {
        margin-top: 0;
        margin-left: $space-050;
      }
    }

    @include tablet() {
      width: 50%;
    }
  }
}
</style>
